import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import CountryDetector from "./CountryDetector";
import MobileBottomNav from "./MobileBottomNav";
import EmailPopup from "./EmailPopup";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { 
  Dices, Menu, X, Star, Gift, FileText, MessageSquare, 
  Users, Mail, Shield, ChevronDown, Search, Facebook, 
  Twitter, Instagram, Youtube, Gamepad2, Zap
} from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import Newsletter from "./Newsletter";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Casinos", path: "/casinos" },
  { name: "Bonuses", path: "/bonuses" },
  { name: "Blog", path: "/blog" },
  { name: "Complaint", path: "/complaint" },
];

const moreLinks = [
  { name: "Partnership", path: "/partnership" },
  { name: "About Us", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export default function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [casinoList, setCasinoList] = useState([]);

  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    axios.get(process.env.REACT_APP_BACKEND_URL + "/api/casinos")
      .then(r => setCasinoList(r.data))
      .catch(() => {});
  }, []);

  const navigate = useNavigate();
  const handleSearch = (e) => {
    if (e.key === "Enter" && searchVal.trim()) {
      navigate(`/casinos?q=${encodeURIComponent(searchVal.trim())}`);
      setSearchVal("");
      setSearchOpen(false);
    }
  };
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen flex flex-col">
      {/* Top Ad Banner - Google AdSense Ready */}
      <div className="w-full bg-muted/30 py-2">
        <div className="max-w-7xl mx-auto px-4">
          <a href="https://fgrns.lynmonkel.com/?mid=389405_2246229" target="_self" rel="noopener noreferrer" className="block">
            <div className="rounded-lg overflow-hidden h-[90px] flex items-center justify-between px-8 cursor-pointer hover:opacity-90 transition-opacity" style={{background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)", border: "1px solid #e5a020"}}>
              <div className="flex items-center gap-4">
                <img src="https://5gringos.com/favicon.ico" alt="5Gringos" className="w-12 h-12 rounded-lg"  loading="lazy"/>
                <div>
                  <div className="text-white font-black text-xl">5Gringos Casino</div>
                  <div className="text-yellow-400 font-bold text-sm">🎁 100% up to £500 + 200 Free Spins</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-white/70 text-sm hidden md:block">⚡ Instant Registration • 24/7 Support</div>
                <div className="bg-yellow-500 hover:bg-yellow-400 text-black font-black px-6 py-2 rounded-full text-sm whitespace-nowrap">CLAIM BONUS →</div>
              </div>
            </div>
          </a>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-card/95 border-b border-border">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-14">
            {/* Logo */}
            <Link 
              to="/" 
              className="flex items-center gap-2 group"
              data-testid="logo-link"
            >
              <div className="w-9 h-9 rounded-lg gradient-neon flex items-center justify-center">
                <Dices className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="text-lg font-bold text-white tracking-tight font-['Montserrat']">
                  Play<span className="text-secondary">Spiro</span>
                </span>
                <p className="text-[9px] text-muted-foreground -mt-1">Casino • Slots • Crash</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
                  className={`px-3 py-2 rounded-lg font-medium text-sm transition-colors ${
                    isActive(link.path)
                      ? "bg-primary/20 text-primary"
                      : "text-white/70 hover:text-white hover:bg-muted"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              
              {/* More Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setMoreMenuOpen(!moreMenuOpen)}
                  onBlur={() => setTimeout(() => setMoreMenuOpen(false), 150)}
                  className="px-3 py-2 rounded-lg font-medium text-sm text-white/70 hover:text-white hover:bg-muted transition-colors flex items-center gap-1"
                  data-testid="nav-more-btn"
                >
                  More <ChevronDown className={`w-3 h-3 transition-transform ${moreMenuOpen ? "rotate-180" : ""}`} />
                </button>
                
                {moreMenuOpen && (
                  <div className="absolute top-full right-0 mt-1 w-40 bg-card border border-border rounded-lg overflow-hidden shadow-lg">
                    {moreLinks.map((link) => (
                      <Link
                        key={link.path}
                        to={link.path}
                        className="block px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-muted transition-colors"
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Search & CTA */}
            <div className="hidden md:flex items-center gap-2">
              <div className="relative" style={{zIndex:1000}}>
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  placeholder="Search casinos..."
                  className="pl-9 w-44 h-9 bg-muted border-border text-white placeholder:text-muted-foreground text-sm"
                  style={{borderColor: searchVal ? "#a855f7" : undefined}}
                  data-testid="search-input"
                  value={searchVal}
                  onChange={e => setSearchVal(e.target.value)}
                  onKeyDown={handleSearch}
                  onFocus={() => setSearchOpen(true)}
                  onBlur={() => setTimeout(() => setSearchOpen(false), 200)}
                />
                {searchOpen && searchVal.length > 0 && (
                  <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,minWidth:"300px",background:"linear-gradient(135deg,#1a0533,#2d0a5e)",border:"1px solid rgba(168,85,247,0.4)",borderRadius:"12px",boxShadow:"0 8px 32px rgba(0,0,0,0.5)",overflow:"hidden",zIndex:9999}}>
                    {casinoList.filter(c =>
                      c.name.toLowerCase().includes(searchVal.toLowerCase()) ||
                      (c.bonus_description||"").toLowerCase().includes(searchVal.toLowerCase())
                    ).slice(0,5).map(c => (
                      <div key={c.id}
                        onMouseDown={() => { navigate(`/casinos/${c.slug}`); setSearchVal(""); setSearchOpen(false); }}
                        style={{padding:"10px 14px",cursor:"pointer",borderBottom:"1px solid rgba(255,255,255,0.05)",display:"flex",alignItems:"center",gap:"10px"}}
                        onMouseEnter={e=>e.currentTarget.style.background="rgba(168,85,247,0.15)"}
                        onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                        <img src={c.logo} alt={c.name} style={{width:"30px",height:"30px",borderRadius:"6px",objectFit:"cover",flexShrink:0}} onError={e=>e.target.style.display="none"} />
                        <div>
                          <div style={{color:"white",fontWeight:"600",fontSize:"0.85rem"}}>{c.name}</div>
                          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"0.7rem"}}>{c.bonus_amount} • {c.free_spins} FS</div>
                        </div>
                      </div>
                    ))}
                    {casinoList.filter(c => c.name.toLowerCase().includes(searchVal.toLowerCase())).length === 0 && (
                      <div style={{padding:"12px",color:"rgba(255,255,255,0.4)",fontSize:"0.85rem",textAlign:"center"}}>No results found</div>
                    )}
                    <div
                      onMouseDown={() => { navigate(`/casinos?q=${encodeURIComponent(searchVal)}`); setSearchVal(""); setSearchOpen(false); }}
                      style={{padding:"10px 14px",cursor:"pointer",background:"rgba(168,85,247,0.1)",textAlign:"center",color:"#a855f7",fontSize:"0.8rem",fontWeight:"600"}}
                      onMouseEnter={e=>e.currentTarget.style.background="rgba(168,85,247,0.25)"}
                      onMouseLeave={e=>e.currentTarget.style.background="rgba(168,85,247,0.1)"}>
                      🔍 See all results for "{searchVal}"
                    </div>
                  </div>
                )}
              </div>
              <Link to="/bonuses">
                <Button className="btn-glow gradient-neon text-white font-semibold rounded-full px-5 h-9 text-sm" data-testid="get-bonus-btn">
                  Get Bonus
                </Button>
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden py-3 border-t border-border">
              <div className="flex flex-col gap-1">
                {[...navLinks, ...moreLinks].map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
                      isActive(link.path)
                        ? "bg-primary/20 text-primary"
                        : "text-white/70 hover:text-white hover:bg-muted"
                    }`}
                  >
                    {link.name}
                  </Link>
                ))}
                <div className="pt-3 px-4">
                  <Link to="/bonuses" onClick={() => setMobileMenuOpen(false)}>
                    <Button className="w-full btn-glow gradient-neon text-white font-semibold rounded-full h-10 text-sm">
                      Get Bonus
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>

      {/* Newsletter Section */}
      <Newsletter />

      {/* Footer */}
      <footer className="bg-card border-t border-border">
        <div className="max-w-7xl mx-auto px-4 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-3">
                <div className="w-9 h-9 rounded-lg gradient-neon flex items-center justify-center">
                  <Dices className="w-5 h-5 text-white" />
                </div>
                <span className="text-lg font-bold text-white font-['Montserrat']">
                  Play<span className="text-secondary">Spiro</span>
                </span>
              </Link>
              <p className="text-white/60 text-sm mb-3">
                Your trusted source for casino, slots, and crash game reviews. Find the best bonuses and gaming guides.
              </p>
              <div className="flex gap-2">
                {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
                  <a 
                    key={i} 
                    href="#" 
                    className="w-8 h-8 rounded-full bg-muted flex items-center justify-center text-white/60 hover:bg-primary/20 hover:text-primary transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                ))}
              </div>
            </div>

            {/* Games */}
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2 text-sm">
                <Gamepad2 className="w-4 h-4 text-secondary" /> Game Types
              </h4>
              <ul className="space-y-2">
                {[
                  { name: "Casino Reviews", path: "/casinos" },
                  { name: "Slot Games", path: "/casinos" },
                  { name: "Crash Games", path: "/casinos" },
                  { name: "Live Dealer", path: "/casinos" },
                ].map((link) => (
                  <li key={link.path + link.name}>
                    <Link 
                      to={link.path} 
                      className="text-white/60 hover:text-primary transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2 text-sm">
                <FileText className="w-4 h-4 text-secondary" /> Resources
              </h4>
              <ul className="space-y-2">
                {[
                  { name: "Best Bonuses", path: "/bonuses" },
                  { name: "Gaming Guides", path: "/blog" },
                  { name: "Submit Complaint", path: "/complaint" },
                  { name: "Partnership", path: "/partnership" },
                ].map((link) => (
                  <li key={link.path}>
                    <Link 
                      to={link.path} 
                      className="text-white/60 hover:text-primary transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold mb-3 flex items-center gap-2 text-sm">
                <Mail className="w-4 h-4 text-secondary" /> Contact
              </h4>
              <ul className="space-y-2 text-sm">
                <li className="text-white/60">
                  <span className="text-white/80 block text-xs">Support:</span>
                  support@playspiro.com
                </li>
                <li className="text-white/60">
                  <span className="text-white/80 block text-xs">Partnership:</span>
                  partner@playspiro.com
                </li>
              </ul>
            </div>
          </div>

          {/* Footer Sportuna Banner */}
<div className="mb-6" data-testid="ad-footer">
  <a
  href="https://track.jiraff.io/click?o=1747&a=187"
  rel="nofollow sponsored"
  className="block rounded-lg overflow-hidden hover:opacity-90 transition"
>
  <img
    src="https://i.postimg.cc/1XddCPmY/sportuna.jpg"
    alt="Sportuna Welcome Bonus"
    className="w-full h-auto rounded-lg"
  />
</a>
</div>

          {/* Bottom Bar */}
          <div className="border-t border-border pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-white/40 text-xs">
              © 2026 PlaySpiro. All rights reserved. Casino, Slots & Crash Game Reviews.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="text-white/40 hover:text-white text-xs transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-white/40 hover:text-white text-xs transition-colors">
                Terms & Conditions
              </Link>
            </div>
            <div className="flex items-center gap-2 text-white/40 text-xs">
              <Shield className="w-3 h-3" />
              <span>18+ | Gamble Responsibly</span>
            </div>
          </div>
        </div>
      </footer>
      <CountryDetector />
      <MobileBottomNav />
      <EmailPopup />
    </div>
  );
}
